import * as React from "react";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { SessionLogResponse } from "../../../../services/types/clientTypes";
import CclDataGridToolbar from "../../../../components/common/cclDataGridToolbar/cclDataGridToolbar";

export interface SessionLogDataGridProProps {
    sessionLogList: SessionLogResponse[] | undefined;
    showToolbar: boolean;
    isLoading: boolean;
}

export const SessionLogDataGridPro: React.FC<SessionLogDataGridProProps> = (props) => {
    const COLUMNS: GridColDef[] = [
        {
            field: "sessionId",
            headerName: "User Name",
            type: "number",
            flex: 0.15,
            headerAlign: "left",
            align: "left",
        },
        {
            field: "sessionTime",
            headerName: "Date",
            valueGetter: (params: any) => new Date(params.row.sessionTime),
            type: "dateTime",
            flex: 0.2,
            headerAlign: "left",
            align: "left",
        },
        {
            field: "action",
            headerName: "Change Type",
            type: "string",
            flex: 0.25,
            headerAlign: "left",
            align: "left",
        },
        {
            field: "detail",
            headerName: "Change",
            type: "string",
            flex: 0.4,
            headerAlign: "left",
            align: "left",
        },
    ];

    return (
        <DataGridPro
            getRowId={(row) => row.sessionKey}
            rows={props.sessionLogList == null ? [] : props.sessionLogList}
            columns={COLUMNS}
            loading={props.isLoading}
            components={{ Toolbar: CclDataGridToolbar }}
            componentsProps={{
                toolbar: {
                    showSaveState: false,
                    savestate: null,
                    clearstate: null,
                    hideSettingsButtons: true,
                    anySelected: null,
                },
            }}
            disableSelectionOnClick
            initialState={{
                sorting: {
                    sortModel: [{ field: "sessionTime", sort: "desc" }],
                },
            }}
        />
    );
};

export default SessionLogDataGridPro;
